export class EmpresasAfiliadas {
    idEmpresa?: Number = -1;
    idEmpresaAfiliada?: String = "";
    idGrupo?: number = -1;
    nombre?: string = "";
    nombreComercial?: string = "";
    descripcion?: string = "";
    direccion?: string = "";
    colonia?: string = "";
    estado?: string = "";
    ciudad?: string = "";
    codigoPostal?: string = "";
    telefono?: string = "";
    giro?: string = "";
    logoTipo?: string = "";
    estatus?: string = "";
    idUsuario?: Number = -1;
    idUsuarioUM?: Number = -1;
    seleccionP?: boolean = false;
}
